import { render } from "./NemView.vue?vue&type=template&id=3ec8bb8f&scoped=true"
import script from "./NemView.vue?vue&type=script&lang=js"
export * from "./NemView.vue?vue&type=script&lang=js"

import "./NemView.vue?vue&type=style&index=0&id=3ec8bb8f&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Documents\\Евадент\\eva\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ec8bb8f"]])

export default __exports__